import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import { useCanonical } from 'layout/canonical/useCanonical';
import { useRouter } from 'next/router';
import { useCountryCodeTitle } from 'shared/hooks';
import { LOCALES } from 'localization/constants/configEnums';

export function GlobalMetadata() {
  const siteTitle = 'GOAT.com';
  const { t } = useTranslation();
  const canonical = useCanonical();
  const titleWithCountryCode = useCountryCodeTitle({
    defaultTitle: t(`layout.title`, `Buy and Sell Authentic Sneakers, Apparel, and Accessories `),
  });

  const { asPath, locales } = useRouter();
  const path = asPath?.split(/[#?]/)?.[0];
  const baseUrl = 'https://www.goat.com';
  const enUSUrl = `${baseUrl}${path}`;

  return (
    <Head>
      <link
        rel="apple-touch-icon"
        href="/images/icons/apple-touch-icon.png"
        key="apple-touch-icon"
      />
      <link rel="icon" href="/favicon.ico" key="favicon" />
      <link rel="manifest" href="/manifest.json" key="manifest" />
      <meta
        name="description"
        content={t(
          `siteDescription`,
          `The global platform for the greatest products from the past, present and future. Shop new and used sneakers, apparel and accessories.`,
        )}
        key="description"
      />
      <meta
        name="og:description"
        content={t(
          `siteDescription`,
          `The global platform for the greatest products from the past, present and future. Shop new and used sneakers, apparel and accessories.`,
        )}
        key="og:description"
      />
      <meta name="theme-color" content="#000" key="theme-color" />
      <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0 maximum-scale=1.0"
        key="viewport"
      />
      <meta property="og:image" content="/images/icons/goat-logo-512.png" key="og:image" />
      <meta property="og:title" content={siteTitle} key="og:title" />
      <title key="title">{titleWithCountryCode}</title>
      {/* Create Alternate Links for all locales */}
      {locales.map((locale) => {
        let href = `${baseUrl}${path}`;
        if (locale !== LOCALES.enUS) {
          href = path === '/' ? `${baseUrl}/${locale}` : `${baseUrl}/${locale}${path}`;
        }
        return <link key={locale} rel="alternate" hrefLang={locale} href={href} />;
      })}
      <link rel="alternate" hrefLang="x-default" href={enUSUrl} />
      <link rel="canonical" href={canonical} />
    </Head>
  );
}
